import { render, staticRenderFns } from "./UserFollowSettingsModal.vue?vue&type=template&id=7a011a37"
import script from "./UserFollowSettingsModal.vue?vue&type=script&lang=js"
export * from "./UserFollowSettingsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports